import { translateTextWithParam } from '../utils/i18n';
import { defaultValues } from '../data/DefaultTranslationValues';
import { captureMessage } from '../utils/sentryAPI';
import { useAppSelector } from './redux';
import { getIsHubless, getPortal } from '../reducers/Portal';
import { KNOWN_MISSING_DEFAULT_NAV_TRANSLATIONS_KEY, KNOWN_MISSING_NAV_TRANSLATIONS_KEY, NavType } from '../constants';
import { isKnownAndNotExpiredMissingTranslation, logKnownMissingTranslation } from '../utils/missingTranslations';
import { selectIsNavType } from '../selectors';
export const DEFAULT_TRANSLATION_SENTRY_MSG = 'Default translation value used';
export const MISSING_TRANSLATION_SENTRY_MSG = 'Default translation value is not available';
export const usePortal = () => {
  const portal = useAppSelector(getPortal);
  return portal;
};
export const useIsHubless = () => {
  const portal = useAppSelector(getIsHubless);
  return portal;
};
export const useHome = () => {
  const {
    home
  } = useAppSelector(store => store.navItems.byId);
  return home;
};
export const useAppConfig = () => {
  const appConfig = useAppSelector(store => store.appConfig);
  return appConfig;
};
export const useUser = () => {
  const user = useAppSelector(store => store.user);
  return user;
};
export const useExperiments = () => {
  const experiments = useAppSelector(store => store.experiments);
  return experiments;
};
function maybeLogUsingDefaultTranslation(key, isFallbackNav) {
  if (isKnownAndNotExpiredMissingTranslation(key, KNOWN_MISSING_DEFAULT_NAV_TRANSLATIONS_KEY) || isFallbackNav) {
    return;
  }
  logKnownMissingTranslation(key, KNOWN_MISSING_DEFAULT_NAV_TRANSLATIONS_KEY);
  captureMessage(DEFAULT_TRANSLATION_SENTRY_MSG, {
    tags: {
      key,
      project: 'unified-navigation-ui'
    }
  });
}
function maybeLogMissingDefaultTranslation(key) {
  if (isKnownAndNotExpiredMissingTranslation(key, KNOWN_MISSING_NAV_TRANSLATIONS_KEY)) {
    return;
  }
  logKnownMissingTranslation(key, KNOWN_MISSING_NAV_TRANSLATIONS_KEY);
  captureMessage(MISSING_TRANSLATION_SENTRY_MSG, {
    tags: {
      key,
      project: 'unified-navigation-ui'
    }
  });
}
export const useTranslation = () => {
  const translations = useAppSelector(store => store.translations);
  const isFallbackNav = useAppSelector(state => selectIsNavType(state, {
    navType: NavType.FALLBACK
  }));
  return {
    t(key, options) {
      if (!key) {
        return '';
      }
      const translation = translateTextWithParam(translations[key] || '', options);
      if (!translation) {
        const defaultTranslation = translateTextWithParam(defaultValues[key] || '', options);
        if (defaultTranslation) {
          maybeLogUsingDefaultTranslation(key, isFallbackNav);
          return defaultTranslation;
        }
        maybeLogMissingDefaultTranslation(key);
      }
      return translation;
    }
  };
};